import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'application/baseComponent';
import { isHybrid } from 'application/pageDataObject';
import { punditStore } from 'stores/punditStore';
import punditActions from 'actions/punditActions';
import userStore from 'stores/userStore';
import { t, } from 'providers/i18nProvider/i18nProvider';
import { MOUNT_POINTS } from 'config/preRenderedSelectorsConfig';

export default class ExternalBetComponent extends BaseComponent {

  constructor(props){
    super(props, [punditStore, userStore]);
  }

  getState(props){
    let { externalBettingProvider: { link, logo }, showExternalBettingProvider, matchStarted } = punditStore;
    let { isLoggedIn, state: { image: userImage } } = userStore;
    return {
      link: link,
      logo: logo,
      loggedIn: isLoggedIn,
      userImage: userImage,
      show: showExternalBettingProvider && !matchStarted
    };
  }

  getCurrentView(graphComponent, loggedInImage){
    return graphComponent ?
          <a className="pundit-external-bet__link" href={ this.state.link }
            target="_blank" onClick={ punditActions.placeBet.part('your_prediction') }
          >
            <p className="pundit-external-bet__link__caption">{ this.props.text }</p>
            <div className="pundit-external-bet__link__img-wrapper">
              <img className="pundit-external-bet__link__img" src={ this.state.logo }/>
            </div>
          </a>
          :
          <div>
            <h1 className="pundit-betting-wrapper__header">
              { t('pundit.what_result') }
            </h1>
            <div className="pundit-external-bet">
              <a className="pundit-external-bet__link" href={ this.state.link }
                target="_blank" onClick={ punditActions.placeBet.part('top_predictors') }
              >
                <p className="pundit-external-bet__link__caption">{ t('pundit.place_your_bet_via') }</p>
                <div className="pundit-external-bet__link__img-wrapper">
                  <img className="pundit-external-bet__link__img" src={ this.state.logo }/>
                </div>
              </a>
            </div>
          </div>;
  }

  shouldComponentUpdate(nextProps, nextState){
    let rootNode = ReactDOM.findDOMNode(this).parentElement;
    if (nextProps.topPredictors) {
      rootNode.className = !nextState.show ? `${MOUNT_POINTS.PUNDIT_TOP_PREDICTORS_EXTERNAL_PROVIDER.substr(1)} ${MOUNT_POINTS.PUNDIT_TOP_PREDICTORS_EXTERNAL_PROVIDER.substr(1)}--hidden` : `${MOUNT_POINTS.PUNDIT_TOP_PREDICTORS_EXTERNAL_PROVIDER.substr(1)}`;
    }
    return true;
  }

  render(){
    let loggedInImage = this.state.loggedIn && !isHybrid && !this.state.noImage
    ? <img className="pundit-section-heading__profile-img" src={ this.state.userImage }/>
    : '';
    let view = this.state.show ?
          this.getCurrentView(!this.props.topPredictors, loggedInImage) :
          <div/>;
    return view;
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditExternalBetComponent.js